import { isBefore, parseISO } from 'date-fns';
import { Boolish, Dateish, Numberish, Stringish } from '../enums/utilities';

export class SortUtil {
  static booleans(a: Boolish, b: Boolish): number {
    return (a ? 1 : -1) - (b ? 1 : -1);
  }

  static numbers = (a: Numberish, b: Numberish) => {
    return (a ?? 0) - (b ?? 0);
  };

  static strings = (a: Stringish, b: Stringish) => {
    return (a ?? '').localeCompare(b ?? '');
  };

  static dates = (a: Dateish, b: Dateish) => {
    const safeA = typeof a === 'string' ? parseISO(a) : a ?? new Date();
    const safeB = typeof b === 'string' ? parseISO(b) : b ?? new Date();
    return isBefore(safeA, safeB) ? -1 : 1;
  };
}
